/**
 * Etapas Kommo → estado de reunión (Agendada / Cancelada / Realizada / No se presentó).
 * @module-isolated analytics-mapeo-reunion
 * @depends analytics-api.js, firebase-auth.js
 */
import { fetchMeetingStages, saveMeetingStages } from '../../../services/analytics-api.js';
import { getIdToken } from '../../../services/firebase-auth.js';

export async function loadMeetingStages() {
  const token = await getIdToken(false);
  return fetchMeetingStages(token);
}

export async function persistMeetingStages(stages, opts) {
  const token = await getIdToken(false);
  return saveMeetingStages(stages, token, opts);
}
